import MediaActionTypes from "./media.types";

export const getJobMedia = (jobid) => ({
  type: MediaActionTypes.GET_MEDIA_FOR_JOB,
  payload: jobid
});

export const getBillMedia = ({ jobid, invoice_number }) => {
  return {
    type: MediaActionTypes.GET_MEDIA_FOR_BILL,
    payload: { jobid, invoice_number }
  };
};

export const setJobMedia = ({ jobid, media, mediaTags }) => ({
  type: MediaActionTypes.SET_MEDIA_FOR_JOB,
  payload: { jobid, media, mediaTags }
});

export const addMediaForJob = ({ jobid, media }) => ({
  type: MediaActionTypes.ADD_MEDIA_FOR_JOB,
  payload: { jobid, media }
});

export const getJobMediaError = ({ jobid, error }) => ({
  type: MediaActionTypes.GET_MEDIA_FOR_JOB_ERROR,
  payload: {
    jobid,
    message: typeof error === "string" ? error : error?.message || "Unknown media request error"
  }
});

export const toggleMediaSelected = ({ jobid, filename, relativePath }) => ({
  type: MediaActionTypes.TOGGLE_MEDIA_SELECTED,
  payload: { jobid, filename, relativePath }
});

export const deselectAllMediaForJob = ({ jobid, targetMediaPaths }) => ({
  type: MediaActionTypes.DESELECT_ALL_MEDIA_FOR_JOB,
  payload: { jobid, targetMediaPaths }
});

export const selectAllmediaForJob = ({ jobid, targetMediaPaths }) => ({
  type: MediaActionTypes.SELECT_ALL_MEDIA_FOR_JOB,
  payload: { jobid, targetMediaPaths }
});

export const selectMediaTypeForJob = ({ jobid, mediaType, targetMediaPaths }) => ({
  type: MediaActionTypes.SELECT_MEDIA_TYPE_FOR_JOB,
  payload: { jobid, mediaType, targetMediaPaths }
});
